<div id="integrationPedido" class="modal fade" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Sincronizar pedidos com o ERP
                </h4>        
            </div>
            <div class="modal-body">
                <form #form="ngForm" novalidate>
                    <div class="row">
                        <div class="form-group col-12">
                            <label for="integrationPedidoPeriodicidade" class="col-form-label">Periodicidade</label>
                            <select class="form-control" name="integrationPedidoPeriodicidade" id="integrationPedidoPeriodicidade" 
                                [ngModel]="entity.periodicidade || ''" (ngModelChange)="entity.periodicidade = $event ? $event : null"
                                #integrationPedidoPeriodicidade="ngModel" required="required">
                                <option *ngFor="let periodicidade of periodicidades" [ngValue]="periodicidade.id">{{getDescricaoPeriodicidade(periodicidade.id)}}</option>
                            </select>  
                            <p class="form-text text-muted">Periodicidade da sincronização dos pedidos</p>
                            <sgt-form-control-error
                                *ngIf="integrationPedidoPeriodicidade.errors && integrationPedidoPeriodicidade.errors.required && integrationPedidoPeriodicidade.dirty"
                                msgError="A periodicidade é obrigatória">
                            </sgt-form-control-error>                                       
                        </div>                        
                    </div> 

                    <!-- Geral -->
                    <div class="row" *ngIf="isPeriodicidadeGeral()">
                        <div class="col-12">
                            <div class="row">
                                <div class="form-group col-12">
                                    <label class="col-form-label" for="integrationPedidoDataInicialBase">Data Inicial</label>
                                    <sgt-datepicker [(ngModel)]="entity.dataInicialBase" name="integrationPedidoDataInicialBase" id="integrationPedidoDataInicialBase"
                                        #integrationPedidoDataInicialBase="ngModel" [ngControl]="integrationPedidoDataInicialBase" required="required">
                                    </sgt-datepicker>
                                    <p class="form-text text-muted">Irá sincronizar os pedidos lançados a partir desta data</p>
                                    <sgt-form-control-error
                                        *ngIf="integrationPedidoDataInicialBase.errors && integrationPedidoDataInicialBase.errors.required && integrationPedidoDataInicialBase.dirty"
                                        msgError="A data inicial é obrigatória">
                                    </sgt-form-control-error>  
                                </div>                         
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="alert alert-warning" role="alert">
                                        <i class="fas fa-exclamation-triangle" aria-hidden="true"></i> Atenção! Se você informar uma data inicial muito antiga a sincronização pode levar vários minutos.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>  

                    <div class="row">
                        <div class="form-group col-12">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.execReadAndUpdateIntegration" name="integrationPedidoExecReadAndUpdateIntegration" id="integrationPedidoExecReadAndUpdateIntegration">
                                <label class="custom-control-label" for="integrationPedidoExecReadAndUpdateIntegration">Sincronizar pedidos lançados no Sogivendas</label>
                            </div>
                            <p class="form-text text-muted">Marque esta opção para sincronizar os pedidos que foram lançados no Sogivendas</p>                                
                        </div>                        
                    </div> 
                    <div class="row">
                        <div class="form-group col-12">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.execReadIntegrationErp" name="integrationPedidoExecReadIntegrationErp" id="integrationPedidoExecReadIntegrationErp">
                                <label class="custom-control-label" for="integrationPedidoExecReadIntegrationErp">Sincronizar pedidos lançados no ERP</label>
                            </div>    
                            <p class="form-text text-muted">Marque esta opção para sincronizar os pedidos que foram lançados no ERP</p>                          
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="execute()" [disabled]="form.invalid">
                    Sincronizar
                </button>              
                <button type="button" class="btn btn-light" (click)="close()">
                    Cancelar
                </button>
            </div>            
        </div>
    </div>
</div>